import { AxiosError, isCancel } from "axios";

// import segment from "@/ui/helpers/integrations/analytics/segment";

export class ApiError<T = unknown> extends Error {
  constructor(cause: AxiosError<T>, message?: string) {
    super(message ?? `ApiError: ${cause.message}`);
    this.cause = cause;

    const error_type =
      cause?.response?.status?.toString() || cause?.code || "Unknown Error";
    const context_page_url = window.location.href;
    const error_message = this.cleanErrorMessage(cause);
    const api_endpoint = cause?.response?.config?.url || cause?.config?.url;

    // segment.trackAPIError(
    //   error_type,
    //   api_endpoint,
    //   context_page_url,
    //   error_message,
    // );
  }

  cause: AxiosError;

  get data() {
    return this.cause.response?.data as any;
  }

  get status() {
    return this.cause.response?.status;
  }

  get statusText() {
    return this.cause.response?.statusText;
  }

  get config() {
    return this.cause.response?.config;
  }
  get request() {
    return this.cause.request;
  }

  get isCancel() {
    return isCancel(this.cause);
  }

  private cleanErrorMessage(cause: AxiosError): string {
    const errorData = cause?.response?.data;
    if (errorData) {
      if (typeof errorData === "string") {
        return errorData;
      } else if (typeof errorData === "object" && "message" in errorData) {
        return (errorData as { message: string }).message;
      } else if (typeof errorData === "object" && "errorMessage" in errorData) {
        return (errorData as { errorMessage: string }).errorMessage;
      }
    }
    return cause.message;
  }
}

/**
 * Type guard to check if an error is an AxiosError.
 * @param e - The error to check.
 * @returns True if the error is an AxiosError, otherwise false.
 */
export function isAxiosError(e: unknown): e is AxiosError {
  if (typeof e !== "object" || e === null) {
    return false;
  }
  return (e as AxiosError).isAxiosError === true;
}
